import { MoreOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getData, postData, putData, deleteData } from "../../api/api";
import ComDateConverter from "./../../Components/ComDateConverter/ComDateConverter";
import {
  Pagination,
  Spin,
  Input,
  Modal,
  Button,
  Popover,
  notification,
  Image,
} from "antd";
import { useNotification } from "../../Notification/Notification";
import ComUpImg from "../../Components/ComUpImg/ComUpImg";
import { useStorage } from "../../hooks/useLocalStorage";
import ComModal from "../../Components/ComModal/ComModal";

export default function MyForums() {
  const [posts, setPosts] = useState([]); // State to store posts
  const [loading, setLoading] = useState(false); // State to handle loading indicator
  const [totalPosts, setTotalPosts] = useState(0); // Total posts count for pagination
  const [page, setPage] = useState(1); // Current page
  const { notificationApi } = useNotification();
  const [images, setImages] = useState([]); // State for new images
  const [existingImages, setExistingImages] = useState([]); // State for existing images
  const [content, setContent] = useState(""); // Post content for new post
  const [disabled, setDisabled] = useState(false); // Submit button state
  const [use, setUse] = useStorage("use", null);
  const [resetFileList, setResetFileList] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingPost, setEditingPost] = useState(null);
  const [postContent, setPostContent] = useState("");
  const [combinedImages, setCombinedImages] = useState([]);
  // Content for editing post

  // Fetch posts data
  const callData = () => {
    getData(
      `/posts?accountId=${use.id}&status=Active&pageNumber=${
        page - 1
      }&pageSize=10`
    )
      .then((e) => {
        setPosts(e.data.data);
        setTotalPosts(e.data.pagination.totalRow);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // Initial data load and page change effect
  useEffect(() => {
    setLoading(true);
    callData();
  }, [page]);

  // Handle pagination
  const handlePageChange = (page) => {
    setPage(page);
  };

  // Create new post
  const onSubmit = () => {
    // Validation
    if (!images || (images.length === 0 && existingImages.length === 0)) {
      notificationApi("error", "Invalid Image", "Please select an image.");
      return;
    }
    if (!content.trim()) {
      notificationApi(
        "error",
        "Invalid Content",
        "Please enter content for the post."
      );
      return;
    }

    setDisabled(true);
    const formData = new FormData();

    // Add images to formData
    images.forEach((file) => formData.append("images", file));
    
    // Add content
    formData.append("content", content);

    postData("/posts", formData)
      .then((response) => {
        notificationApi("success", "Success", "Post created successfully");
        setDisabled(false);
        callData();
        setContent("");
        setImages([]);
        setResetFileList(!resetFileList);
        setIsModalVisible(false);
      })
      .catch((error) => {
        console.error(error);
        setDisabled(false);
        notificationApi("error", "Failed", "Please try again");
      });
  };

  // Handle image upload changes
  const onChange = (data) => {
    const selectedImages = data;
    const newImages = selectedImages.map((file) => file.originFileObj);
    setImages(newImages);
  };

  // Modal controls
  const showModal = () => {
    setIsModalVisible(true);
    setExistingImages([]); // Clear existing images for new post
    setImages([]);
    setContent("");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingPost(null);
    setPostContent("");
    setExistingImages([]);
    setImages([]);
    setContent("");
  };

  // Handle edit post click
  const handleEditClick = (post) => {
    console.log("post",post);
    setEditingPost(post);
    setPostContent(post.content);
    setExistingImages(post.postImages || []); // Set existing images
    setImages([]); // Clear new images
    setIsModalVisible(true);
  };

  // Handle save edited post
  const handleSaveEdit = () => {
    if (!postContent.trim()) {
      notificationApi(
        "error",
        "Invalid Content",
        "Please enter content for the post."
      );
      return;
    }

    // Validate at least one image (either existing or new)
    if (images.length === 0 && existingImages.length === 0) {
      notificationApi(
        "error",
        "Invalid Image",
        "Please include at least one image."
      );
      return;
    }

    const formData = new FormData();
    formData.append("content", postContent);
    formData.append("status", "Active");
    


    // Add new images if any
    if (images.length > 0) {
      images.forEach((file) => formData.append("images", file));
    }

    // existingImages.forEach((image, index) => {
    //   formData.append(`existingImages[${index}]`, image.url);
    //   // Assuming each image object has an 'id' that the server can use to recognize it
    //   formData.append(`existingImageIds[${index}]`, image.id);
    // });
  

    putData(`/posts`, editingPost.id, formData)
      .then(() => {
        notificationApi("success", "Success", "Post updated successfully");
        setEditingPost(null);
        callData();
        setIsModalVisible(false);
        setExistingImages([]);
        setImages([]);
      })
      .catch((error) => {
        console.error(error);
        notificationApi("error", "Failed", "Failed to update post");
      });
  };

  // Handle delete post
  const handleDelete = (postId) => {
    Modal.confirm({
      title: "Are you sure you want to delete this post?",
      content: "This action cannot be undone.",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        const formData = new FormData();
        formData.append("status", "InActive");
        
        putData(`/posts`, postId, formData)
          .then(() => {
            notificationApi(
              "success",
              "Post Deleted",
              "The post was deleted successfully."
            );
            callData();
          })
          .catch((error) => {
            console.error(error);
            notificationApi(
              "error",
              "Delete Failed",
              "Failed to delete the post."
            );
          });
      },
    });
  };

  // Remove existing image
  const handleRemoveExistingImage = (index) => {
    const newImages = existingImages.filter((_, i) => i !== index);
    setExistingImages(newImages);
    

  };

  return (
    <div className="mb-4 bg-white border border-gray-300 rounded-lg shadow-sm 2xl:col-span-1 sm:px-6 sm:py-4 mt-2">
      <div className="max-w-4xl mx-auto min-h-[50vh]">
        {/* Create Post Button */}
        {use?.id && (
          <div className="mb-4 text-center flex justify-end">
            <Button
              type="primary"
              onClick={showModal}
              className="rounded-lg bg-blue-600 hover:bg-blue-700 text-white"
            >
              Create New Post
            </Button>
          </div>
        )}

        {/* Posts Display */}
        <div className="divide-y">
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <Spin size="large" />
            </div>
          ) : (
            posts.map((post) => (
              <div key={post.id} className="p-4 hover:bg-gray-50">
                <div className="flex gap-4">
                  <div>
                    <img
                      src={post?.createdByNavigation?.avatar}
                      alt={post.id}
                      className="w-8 h-8 rounded-full"
                    />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <Link
                        to={`/Forums/${post.id}`}
                        className="text-lg font-medium text-blue-600 hover:text-blue-800 line-clamp-3"
                      >
                        {post.content}
                      </Link>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <a href="#" className="hover:underline">
                        {post.createdByNavigation.firstName}{" "}
                        {post.createdByNavigation.lastName}
                      </a>
                      <span>·</span>
                      <span>
                        <ComDateConverter>{post.createAt}</ComDateConverter>
                      </span>
                    </div>
                    
                    {/* Display post images in preview */}
                    {post.images && post.images.length > 0 && (
                      <div className="mt-2 flex flex-wrap gap-2">
                        {post.images.map((image, index) => (
                          <Image
                            key={index}
                            src={image.url}
                            alt={`Post image ${index + 1}`}
                            className="w-20 h-20 object-cover rounded"
                            preview={{
                              mask: "View",
                            }}
                          />
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Actions Popover */}
                  <Popover
                    content={
                      <div className="flex flex-col gap-2">
                        <Button onClick={() => handleEditClick(post)}>
                          Edit
                        </Button>
                        <Button
                          danger
                          onClick={() => handleDelete(post.id)}
                        >
                          Delete
                        </Button>
                      </div>
                    }
                    trigger="click"
                    placement="bottomRight"
                  >
                    <MoreOutlined className="cursor-pointer text-gray-500 hover:text-gray-700" />
                  </Popover>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-4">
          <Pagination
            current={page}
            pageSize={10}
            total={totalPosts}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>

        {/* Create/Edit Modal */}
        <ComModal width={600} isOpen={isModalVisible} onClose={handleCancel}>
          <div className="text-lg font-semibold mb-4">
            {editingPost ? "Edit Post" : "Create New Post"}
          </div>
          
          {/* Content Input */}
          <Input.TextArea
            value={editingPost ? postContent : content}
            onChange={(e) =>
              editingPost
                ? setPostContent(e.target.value)
                : setContent(e.target.value)
            }
            rows={4}
            placeholder="Enter post content"
            className="mb-4"
          />
          
          {/* Existing Images Display */}
          {existingImages.length > 0 && (
  <div className="mb-4">
    <h2 className="text-lg font-medium mb-2">Images From post</h2>
    <div className="flex flex-wrap gap-2">
      {existingImages.map((image, index) => (
        <div key={index} className="relative w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
          <Image
            src={image.url}
            alt={`Existing image ${index + 1}`}
            className="w-full h-auto object-cover rounded"
            preview={{
              mask: "View",
            }}
          />
           <Button
            type="text"
            danger
            className="absolute -top-2 -right-2 rounded-full w-6 h-6 p-0 flex items-center justify-center"
            onClick={() => handleRemoveExistingImage(index)}
          >
            ×
          </Button> 
        </div>
      ))}
    </div>
  </div>
)}

          {/* Image Upload */}
          <div className="mb-4">
            <h2 className="text-lg font-medium mb-2">
              {editingPost ? "Add New Images" : "Upload Images"}
            </h2>
            <ComUpImg
              onChange={onChange}
              error={
                images.length === 0 && existingImages.length === 0
                  ? "Please select an image"
                  : ""
              }
              required={!editingPost && existingImages.length === 0}
              resetFileList={resetFileList}
              multiple
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-center">
            <Button
              type="primary"
              onClick={editingPost ? handleSaveEdit : onSubmit}
              disabled={disabled}
              loading={disabled}
              className="min-w-[120px]"
            >
              {disabled
                ? editingPost
                  ? "Saving..."
                  : "Creating..."
                : editingPost
                ? "Save Post"
                : "Create Post"}
            </Button>
          </div>
        </ComModal>
      </div>
    </div>
  );
}